import httpClient from "./httpClient";

// --- Templates ---
export function listSmsTemplates() {
  return httpClient.get("/sms/templates").then((res) => res.data.data);
}
export function createSmsTemplate(payload) {
  return httpClient.post("/sms/templates", payload).then((res) => res.data.data);
}
export function updateSmsTemplate(id, payload) {
  return httpClient.put(`/sms/templates/${id}`, payload).then((res) => res.data.data);
}
export function deleteSmsTemplate(id) {
  return httpClient.delete(`/sms/templates/${id}`).then((res) => res.data);
}

export function listAttendanceSmsTemplates() {
  return httpClient.get("/sms/attendance-templates").then((res) => res.data.data);
}
export function createAttendanceSmsTemplate(payload) {
  return httpClient.post("/sms/attendance-templates", payload).then((res) => res.data.data);
}
export function updateAttendanceSmsTemplate(id, payload) {
  return httpClient.put(`/sms/attendance-templates/${id}`, payload).then((res) => res.data.data);
}
export function deleteAttendanceSmsTemplate(id) {
  return httpClient.delete(`/sms/attendance-templates/${id}`).then((res) => res.data);
}

// --- Balance ---
export function getSmsBalance() {
  return httpClient.get("/sms/balance/view").then((res) => res.data.data);
}
export function getSmsBalanceForInstitute(instituteId) {
  return httpClient.get("/sms/balance/single/institute", { params: { instituteId } }).then((res) => res.data.data);
}
export function getAllSmsBalances() {
  return httpClient.get("/sms/balance/all/institute").then((res) => res.data.data);
}
export function giveSmsBalance(payload) {
  return httpClient.post("/sms/balance/give", payload).then((res) => res.data);
}

// --- Sending ---
export function sendManyToManySms(payload) {
  return httpClient.post("/sms/send/many-to-many", payload).then((res) => res.data);
}
export function sendSmsToStaff(payload) {
  return httpClient.post("/sms/send/staff", payload).then((res) => res.data);
}
export function sendSmsToStudents(payload) {
  return httpClient.post("/sms/send/student", payload).then((res) => res.data);
}
export function sendCustomSms(payload) {
  return httpClient.post("/sms/send/student/custom", payload).then((res) => res.data);
}
export function sendSmsToAllStudents(payload) {
  return httpClient.post("/sms/send/all/student", payload).then((res) => res.data);
}
export function absentStudentList(academicYear, attendanceDate, shiftId) {
  return httpClient.get("/sms/send/absent/student/list", { params: { academicYear, attendanceDate, shiftId } }).then((res) => res.data.data);
}
export function sendAbsentSms(payload) {
  return httpClient.post("/sms/send/absent", payload).then((res) => res.data);
}

// --- Reports ---
export function getSmsLog(fromDate, toDate) {
  return httpClient.get("/sms/reports/log", { params: { fromDate, toDate } }).then((res) => res.data.data);
}
export function getBalanceGivenLog(fromDate, toDate) {
  return httpClient.get("/sms/reports/balance-given-log", { params: { fromDate, toDate } }).then((res) => res.data.data);
}
